import axios from "../utils/axios";

// get file
export const getFile = (id) => {
  return axios.get(`/api/file/id/${id}`);
};

// upload file
export const uploadFile = (data) => {
  return axios.post("/api/file/upload", data);
};
